<template lang="pug">
div
  h1.h3.u-mb-sm.u-lineHeight Table

  CodeSample(name="Default" :pug="defaultPug" :html="defaultHtml" )
    table.table.is-normal.is-black
      thead
        tr
          th ID
          th First Name
          th Last name
          th Address
      tbody
        tr
          td 1
          td Petrina
          td Abbie
          td 4603 pine dr
        tr
          td 2
          td ida
          td gutierrez
          td 1838 poplar dr
        tr
          td 3
          td valerie
          td cox
          td 6250 harrison ct

        tr
          td 4
          td denise
          td martin
          td 1702 auerbach ave




  CodeSample(name="Sizes" :pug="sizesPug" :html="sizesHtml" class="u-mt-md")
    table.table.is-small
      thead
        tr
          th ID
          th First Name
          th Last name
          th Address
      tbody
        tr
          td 1
          td Petrina
          td Abbie
          td 4603 pine dr
        tr
          td 2
          td ida
          td gutierrez
          td 1838 poplar dr
    br
    table.table.is-normal
      thead
        tr
          th ID
          th First Name
          th Last name
          th Address
      tbody
        tr
          td 1
          td Petrina
          td Abbie
          td 4603 pine dr
        tr
          td 2
          td ida
          td gutierrez
          td 1838 poplar dr
    br
    table.table.is-large
      thead
        tr
          th ID
          th First Name
          th Last name
          th Address
      tbody
        tr
          td 1
          td Petrina
          td Abbie
          td 4603 pine dr
        tr
          td 2
          td ida
          td gutierrez
          td 1838 poplar dr

  CodeSample(name="Striped" :pug="stripedPug" :html="stripedHtml" class="u-mt-md")
    table.table.is-striped
      thead
        tr
          th ID
          th First Name
          th Last name
          th Address
      tbody
        tr
          td 1
          td Petrina
          td Abbie
          td 4603 pine dr
        tr
          td 2
          td ida
          td gutierrez
          td 1838 poplar dr
        tr
          td 3
          td valerie
          td cox
          td 6250 harrison ct
        tr
          td 4
          td denise
          td martin
          td 1702 auerbach ave

  CodeSample(name="Relaxed" :pug="relaxedPug" :html="relaxedHtml" class="u-mt-md")
    table.table.is-relaxed
      thead
        tr
          th ID
          th First Name
          th Last name
          th Address
      tbody
        tr
          td 1
          td Petrina
          td Abbie
          td 4603 pine dr
        tr
          td 2
          td ida
          td gutierrez
          td 1838 poplar dr
        tr
          td 3
          td valerie
          td cox
          td 6250 harrison ct
        tr
          td 4
          td denise
          td martin
          td 1702 auerbach ave

  CodeSample(name="Center" :pug="centerPug" :html="topHtml" class="u-mt-md")
    table.table.is-center
      thead
        tr
          th ID
          th First Name
          th Last name
          th Address
      tbody
        tr
          td 1
          td Petrina
          td Abbie
          td 4603 pine dr
        tr
          td 2
          td ida
          td gutierrez
          td 1838 poplar dr
        tr
          td 3
          td valerie
          td cox
          td 6250 harrison ct
            br
            | 6230 harrison ct
            br
            | 6240 harrison ct
        tr
          td 4
          td denise
          td martin
          td 1702 auerbach ave
  CodeSample(name="Align Bottom" :pug="bottomPug" :html="bottomHtml" class="u-mt-md")
    table.table.is-bottom
      thead
        tr
          th ID
          th First Name
          th Last name
          th Address
      tbody
        tr
          td 1
          td Petrina
          td Abbie
          td 4603 pine dr
        tr
          td 2
          td ida
          td gutierrez
          td 1838 poplar dr
        tr
          td 3
          td valerie
          td cox
          td 6250 harrison ct
            br
            | 6230 harrison ct
            br
            | 6240 harrison ct
        tr
          td 4
          td denise
          td martin
          td 1702 auerbach ave




  table.table.is-relaxed.u-mt-md
    thead
      tr
        th Modifier
        th Description
        th Class
    tbody
      tr
        td Size
        td changes the table size
        td
          p .is-small
          p .is-normal
          p .is-large
      tr
        td Striped
        td alternates the background of rows sequentially
        td .is-striped
      tr
        td Center
        td aligns table content to the center
        td .is-center
      tr
        td Relaxed
        td removes table vertical lines
        td .is-relaxed
      tr
        td Top
        td vertically aligns table content to the top
        td .is-top
      tr
        td Bottom
        td vertically aligns table content to the bottom
        td .is-bottom
      tr
        td Middle
        td vertically aligns table content to the middle
        td .is-middle


</template>

<script>
import CodeSample from '~/components/CodeSample';

export default {
  scrollToTop: true,
  layout: 'base',
  head: () => ({
    title: 'Table'
  }),
  components: {
    CodeSample
  },
  data: () => ({
    defaultPug: `table.table
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr
    tr
      td 3
      td valerie
      td cox
      td 6250 harrison ct

    tr
      td 4
      td denise
      td martin
      td 1702 auerbach ave`,
    defaultHtml: `<table class="table">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
    <tr>
      <td>3</td>
      <td>valerie </td>
      <td>cox</td>
      <td>6250 harrison ct </td>
    </tr>
    <tr>
      <td>4</td>
      <td>denise </td>
      <td>martin</td>
      <td>1702 auerbach ave</td>
    </tr>
  </tbody>
</table>`,
    sizesPug: `table.table.is-small
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr


table.table.is-normal
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr


table.table.is-large
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr
`,
    sizesHtml: `<table class="table is-small">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
  </tbody>
</table>


<table class="table is-normal">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
  </tbody>
</table>


<table class="table is-large">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
  </tbody>
</table>`,

    stripedPug: `table.table.is-striped
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr
    tr
      td 3
      td valerie
      td cox
      td 6250 harrison ct
    tr
      td 4
      td denise
      td martin
      td 1702 auerbach ave`,
    stripedHtml: `<table class="table is-striped">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
    <tr>
      <td>3</td>
      <td>valerie </td>
      <td>cox</td>
      <td>6250 harrison ct</td>
    </tr>
    <tr>
      <td>4</td>
      <td>denise </td>
      <td>martin</td>
      <td>1702 auerbach ave</td>
    </tr>
  </tbody>
</table>`,
    relaxedPug: `table.table.is-relaxed
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr
    tr
      td 3
      td valerie
      td cox
      td 6250 harrison ct
    tr
      td 4
      td denise
      td martin
      td 1702 auerbach ave`,
    relaxedHtml: `<table class="table is-relaxed">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
    <tr>
      <td>3</td>
      <td>valerie </td>
      <td>cox</td>
      <td>6250 harrison ct <br/>6230 harrison ct<br/>6240 harrison ct</td>
    </tr>
    <tr>
      <td>4</td>
      <td>denise </td>
      <td>martin</td>
      <td>1702 auerbach ave</td>
    </tr>
  </tbody>
</table>`,
    centerPug: `table.table.is-center
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr
    tr
      td 3
      td valerie
      td cox
      td 6250 harrison ct
    tr
      td 4
      td denise
      td martin
      td 1702 auerbach ave`,
    centerHtml: `<table class="table is-center">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
    <tr>
      <td>3</td>
      <td>valerie </td>
      <td>cox</td>
      <td>6250 harrison ct <br/>6230 harrison ct<br/>6240 harrison ct</td>
    </tr>
    <tr>
      <td>4</td>
      <td>denise </td>
      <td>martin</td>
      <td>1702 auerbach ave</td>
    </tr>
  </tbody>
</table>`,
    topPug: `table.table.is-top
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr
    tr
      td 3
      td valerie
      td cox
      td 6250 harrison ct
        br
        | 6230 harrison ct
        br
        | 6240 harrison ct
    tr
      td 4
      td denise
      td martin
      td 1702 auerbach ave`,
    topHtml: `<table class="table is-top">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
    <tr>
      <td>3</td>
      <td>valerie </td>
      <td>cox</td>
      <td>6250 harrison ct <br/>6230 harrison ct<br/>6240 harrison ct</td>
    </tr>
    <tr>
      <td>4</td>
      <td>denise </td>
      <td>martin</td>
      <td>1702 auerbach ave</td>
    </tr>
  </tbody>
</table>`,
    bottomPug: `table.table.is-bottom
  thead
    tr
      th ID
      th First Name
      th Last name
      th Address
  tbody
    tr
      td 1
      td Petrina
      td Abbie
      td 4603 pine dr
    tr
      td 2
      td ida
      td gutierrez
      td 1838 poplar dr
    tr
      td 3
      td valerie
      td cox
      td 6250 harrison ct
        br
        | 6230 harrison ct
        br
        | 6240 harrison ct
    tr
      td 4
      td denise
      td martin
      td 1702 auerbach ave`,
    bottomHtml: `<table class="table is-bottom">
  <thead>
    <tr>
      <th>ID</th>
      <th>First Name</th>
      <th>Last name</th>
      <th>Address</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Petrina</td>
      <td>Abbie</td>
      <td>4603 pine dr</td>
    </tr>
    <tr>
      <td>2</td>
      <td>ida </td>
      <td>gutierrez</td>
      <td>1838 poplar dr</td>
    </tr>
    <tr>
      <td>3</td>
      <td>valerie </td>
      <td>cox</td>
      <td>6250 harrison ct <br/>6230 harrison ct<br/>6240 harrison ct</td>
    </tr>
    <tr>
      <td>4</td>
      <td>denise </td>
      <td>martin</td>
      <td>1702 auerbach ave</td>
    </tr>
  </tbody>
</table>`,
    disabledPug: 'textarea.textarea.is-normal.is-black.is-disabled is-disabled',
    disabledHtml: '<textarea class="textarea is-normal is-black is-disabled">is-disabled</textarea>'
  })
};
</script>
